import {Inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {BASE_CLIENT, BaseClient} from '../../client/base.client';
import {YzImgCropperComponent} from "./yz-img-cropper.component";

@Injectable({
  providedIn: 'root'
})

export class YzImgCropperService {

  constructor(public dialog: MatDialog,
              @Inject(BASE_CLIENT) private client: BaseClient) {

  }

  /**
   * 图片裁剪
   * @param option
   */
  imgCropper(option: {
               imgFile: any,
               onOk: (value: any) => void,
               fileType?: 'FileEvent' | 'Base64' | 'BlobFile',
               containWithinAspectRatio?: boolean,
               format?: string,
               imageQuality?: number,
               aspectRatio?: number,
               maxSizeMB?: number,
               maxWidthOrHeight?: number
             }
  ) {
    const dialogRef = this.dialog.open(YzImgCropperComponent, {
      panelClass: 'yz-img-cropper-panel',
      closeOnNavigation: true,
      data: {
        imgFile: option.imgFile,
        fileType: (option.fileType == undefined || option.fileType == null) ? 'FileEvent' : option.fileType,
        containWithinAspectRatio: (option.containWithinAspectRatio == undefined || option.containWithinAspectRatio == null) ? false : option.containWithinAspectRatio,
        format: (option.format == undefined || option.format == null) ? 'png' : option.format,
        imageQuality: (option.imageQuality == undefined || option.imageQuality == null) ? 92 : option.imageQuality,
        aspectRatio: (option.aspectRatio == undefined || option.aspectRatio == null) ? 1 / 1 : option.aspectRatio,
        maxSizeMB: (option.maxSizeMB == undefined || option.maxSizeMB == null) ? 1 : option.maxSizeMB,
        maxWidthOrHeight: (option.maxWidthOrHeight == undefined || option.maxWidthOrHeight == null) ? 100 : option.maxWidthOrHeight,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      option.onOk(result ? result : null);
    });
  }

}
